import React from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import { userPartnerSelectors } from "../../selector/user.selector";
import { isValidArray } from "../../utils/utilities";
import { BusCancellationModal } from "../bus-cancel-components/bus-cancellation-modal/bus-cancellation-modal.component";
import { BusDelayModal } from "../bus-cancel-components/bus-delay-modal/bus-delay-modal.component";
import { SendDriverDetails } from "../bus-cancel-components/send-driver-details-modal/send-driver-details-modal.component";
import { checkActionAllowed } from "../../utils/utilities";
import { VIEW_ADMIN_TAB_IN_SEARCH_PAGE, MANAGE_CITIES_IN_SEARCH_PAGE } from "../../utils/constant";
import './admin-tab.style.scss';
import { RemoveCities } from "../remove-cities/remove-cities.component";
import { AssignPartnerCode } from "./assign-partner-code.component";
import { InformOtas } from "../search-components/infrom-ota/infrom-ota.component";
import { ChangeSeatLayout } from "../change-seat-layout/change-seat-layout.component";
import { isChangeLayoutTabAllowed } from "./admin-tab.module";
import { TripExpenseComponent } from "../trip-expense-.component/expense-table-component/trip-expense-component";
import { OTAValidationComponent } from "../ota-validation-component/ota-validation.component";
import { GroupByBranchComponent } from "../group-by-branch-component/group-by-branch.component";
import { ChartTransferComponent } from "../chart-transfer/chart-transfer.component";
import { GetServiceId } from "./get-service-id.component";
import { GetTrackingUrl } from "./get-tracking-url.component";
import { GetOtaUrl } from "./get-ota-url.component";

export const AdminTabComponent = (props) => {

    const {
        schedule,
        vechicleInfoExits
    } = props;

    const partnerDetails = useSelector(userPartnerSelectors);
    const isPartnerCodeAllowed = isValidArray(partnerDetails) && partnerDetails.length > 0;

    if(checkActionAllowed(VIEW_ADMIN_TAB_IN_SEARCH_PAGE)){
        const buttons = [
            <BusCancellationModal schedule={schedule} />,
            checkActionAllowed(MANAGE_CITIES_IN_SEARCH_PAGE)&&<RemoveCities schedule={schedule}/>,
            <InformOtas
                tripId={schedule.trip_id}
                scheduleId={schedule.schedule_id}
            />,
            <SendDriverDetails
                scheduleVechicleId={schedule.schedule_vechicle_id}
                tripVechicleId={schedule.vechicle_id}
                vechicleInfoExits={vechicleInfoExits}
                seatsAvailbility={schedule.seatsAvailbility}
                tripId={schedule.trip_id}
                sentLocation={`${global.userName}(Manage tab)`}
            />,
            isChangeLayoutTabAllowed()&&<ChangeSeatLayout
                tripId = {schedule.trip_id}
                tripRouteId = {schedule.trip_route_id}
            />,
            <TripExpenseComponent
                tripId={schedule.trip_id}
            />,
            <GetServiceId
                schedule={schedule}
            />,
            <GetTrackingUrl
                tripId={schedule.trip_id}
            />,
            <GetOtaUrl
                origin={schedule.origin}
                destination={schedule.destination}
                date={schedule.start_date}
            />,
            <OTAValidationComponent
                tripRouteId={schedule.trip_route_id}
            />,
            <ChartTransferComponent
                schedule={schedule}
            />,
            <GroupByBranchComponent
                tripId={schedule.trip_id}
            />,
            isPartnerCodeAllowed&&<AssignPartnerCode
                tripId={schedule.trip_id}
                partnerCode={schedule.partner_code}
            />,
        ].filter(Boolean);

        const rows = [];
        for(let i=0; i<buttons.length; i+=2){
            rows.push(buttons.slice(i, i+2));
        }

        return(
            <div className="tab-block">
                <div className="search-admin-tab-root">
                    {rows.map((rowButtons, rowIndex) => (
                        <Row key={rowIndex} justify="center" align="middle" gutter={[16,16]}>
                            {rowButtons.map((button, colIndex) => (
                                <Col key={colIndex} className="manage-btn-col">
                                    {button}
                                </Col>
                            ))}
                        </Row>
                    ))}
                </div>
            </div>

        );
    }else{
        return null;
    }
  
}
